import "../css/detail.css";
import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { LOAD_APPLICATION_REQUEST } from "../reducers/adminBusiness";
import {
  hasValue,
  isChecked,
  orDash,
  timeRange,
  moneyRange,
} from "../util/display";

const ApplicationDetail = ({ onSelectMenu, data }) => {
  const businessId = data.businessId;
  const { allUsers, userBusinesses } = useSelector((state) => state.adminUser);
  const { application } = useSelector((state) => state.adminBusiness);
  const user = allUsers?.find((id) => id.id === data.businessId);
  const business = userBusinesses?.find(
    (id) => id.BusinessId === data.businessId
  );
  // 서버는 "그 기업의 공고 목록"을 배열로 돌려줍니다. 그런데 예전 코드는
  // 이걸 공고 하나로 착각하고 application.모집직종 식으로 읽고 있어서,
  // 모든 값이 빈칸으로 나왔습니다. 배열에서 클릭한 공고를 골라냅니다.
  const app = Array.isArray(application)
    ? application.find((a) => a.id === data.applicationId) || application[0]
    : application;
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch({
      type: LOAD_APPLICATION_REQUEST,
      data: {
        businessId,
      },
    });
  }, []);
  return (
    <div className="detail business">
      <div className="detail_container">
        <div
          className="back_btn"
          onClick={() => {
            onSelectMenu(data.previousComponent);
          }}
        >
          돌아가기
        </div>
        <div className="user_box">
          <p>아이디 : {user?.user_member_id}</p>
          <p>회사 이름 : {business?.business_member_companyName}</p>
        </div>
        <div className="title">공고내용</div>
        {app && (
          <>
            <div className="text_box">
              <p className="text_title">채용 제목</p>
              <p className="text_content">{app.business_application_name}</p>
            </div>
          </>
        )}
        {app && (
          <>
            <div className="text_box">
              <p className="text_title">모집 직종</p>
              <p className="text_content">
                {orDash(app.business_application_type)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">모집인원</p>
              <p className="text_content">
                {orDash(app.business_application_number)} 명
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">근무시기</p>
              <p className="text_content">
                {/* "공고일 이후 채용 즉시"를 선택하면 날짜 칸은 비워둔 채
                    신청하게 되어 있습니다. 예전엔 날짜만 보여줘서 이 경우
                    "년 월 부터"처럼 빈칸만 나왔습니다. */}
                {isChecked(app.business_application_startNow)
                  ? "공고일 이후 채용 즉시"
                  : `${app.business_application_startYear || ""}년 ${
                      app.business_application_startMonth || ""
                    }월 ${app.business_application_startDay || ""}일 부터`}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">예상 근무기간</p>
              <p className="text_content">
                {orDash(app.business_application_expectPeriod)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">직무 내용</p>
              <p className="text_content">
                {/* 선택하지 않은 항목까지 전부 표시되던 문제를 함께 바로잡았습니다.
                    선택한 것만 쉼표로 이어서 보여줍니다. */}
                {[
                  [app.business_application_workContent1, "기장·신고"],
                  [app.business_application_workContent2, "결산"],
                  [app.business_application_workContent3, "조정"],
                  [app.business_application_workContent4, "회계감사"],
                  [app.business_application_workContent5, "세무조사"],
                  [app.business_application_workContent6, "컨설팅"],
                  [app.business_application_workContent7, "연구개발비정산"],
                ]
                  .filter(([checked]) => isChecked(checked))
                  .map(([, label]) => label)
                  .join(", ") || "-"}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">사용 프로그램</p>
              <p className="text_content">
                {[
                  isChecked(app.business_application_program) ? "더죤" : "",
                  app.business_application_program1,
                ]
                  .filter(Boolean)
                  .join(", ") || "-"}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">경력</p>
              <p className="text_content">
                {orDash(app.business_application_career)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">학력</p>
              <p className="text_content">
                {orDash(app.business_application_schoolFinal)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">자격·면허</p>
              <p className="text_content">
                {/* 자격증 이름과 별개로 "관계없음 / 필수 / 우대" 선택이 있는데
                    예전엔 자격증 이름만 보여줬습니다. 둘 다 표시합니다. */}
                {[
                  app.business_application_schoolLisence,
                  app.business_application_schoolLisence1,
                ]
                  .filter(Boolean)
                  .join(" ") || "-"}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">임금</p>
              {/* 입력이 없으면 "- ~ -" 대신 대시 하나만 보여줍니다. */}
              <p className="text_content">
                {[
                  isChecked(app.business_application_payType) &&
                    `${app.business_application_payType} :`,
                  moneyRange(
                    app.business_application_payMin,
                    app.business_application_payMax
                  ),
                ]
                  .filter(Boolean)
                  .join(" ")}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">근무 시간</p>
              <p className="text_content">
                {timeRange(
                  app.business_application_workTime1Hour,
                  app.business_application_workTime1Minute,
                  app.business_application_workTime2Hour,
                  app.business_application_workTime2Minute
                )}
                {/* 일수·시간이 비어 있으면 "일 시간"만 덩그러니 남던 것을
                    고쳤습니다. 값이 있을 때만 줄을 추가합니다. */}
                {(hasValue(app.business_application_workTimeDay) ||
                  hasValue(app.business_application_workTimeHour) ||
                  isChecked(app.business_application_workTimeNego)) && (
                  <>
                    <br />
                    {[
                      hasValue(app.business_application_workTimeDay) &&
                        `${app.business_application_workTimeDay}일`,
                      hasValue(app.business_application_workTimeHour) &&
                        `${app.business_application_workTimeHour}시간`,
                      isChecked(app.business_application_workTimeNego) &&
                        "(조정가능)",
                    ]
                      .filter(Boolean)
                      .join(" ")}
                  </>
                )}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">휴게 시간</p>
              <p className="text_content">
                {timeRange(
                  app.business_application_breakTime1Hour,
                  app.business_application_breakTime1Minute,
                  app.business_application_breakTime2Hour,
                  app.business_application_breakTime2Minute
                )}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">근무 장소</p>
              <p className="text_content">
                {orDash(app.business_application_workPlace)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">퇴직 급여</p>
              <p className="text_content">
                {orDash(app.business_application_severancePay)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">고용 형태</p>
              <p className="text_content">
                {orDash(app.business_application_employmentType)}
              </p>
            </div>
            <div className="text_box">
              <p className="text_title">채용우선순위</p>
              <p className="text_content">
                {`근무시작 가능 시기 : ${app.business_application_rank1}`}
                <br />
                {`경력 : ${app.business_application_rank2}`}
                <br />
                {`근무형태 : ${app.business_application_rank3}`}
                <br />
                {`거주지 : ${app.business_application_rank4}`}
                <br />
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ApplicationDetail;
